import { render, staticRenderFns } from "./ReportComponent.vue?vue&type=template&id=54da5b16&scoped=true"
import script from "./ReportComponent.vue?vue&type=script&lang=js"
export * from "./ReportComponent.vue?vue&type=script&lang=js"
import style0 from "./ReportComponent.vue?vue&type=style&index=0&id=54da5b16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54da5b16",
  null
  
)

export default component.exports